import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from '../../../styles/colors';
import { ZeeFontRegular } from '../../../styles/font';
import { MediaBP as MQ } from '../../../styles/mediaQuery';
import { flex } from '../../../styles/utils';

export const searchSuggestionsWrapper = css`
  ${ZeeFontRegular(14, 48)};
  color: ${colors.PrimaryWhiteColor};
  background-color: ${colors.SearchFilterDropdownBg};
  text-align: left;
  position: absolute;
  left: 16px;
  right: 0;
  top: 85px;
  bottom: 0;
  overflow: hidden;
  z-index: 2;
  ${MQ.MediaLg} {
    ${flex('column', '', '')}
    top: 40px;
    left: 0;
    right: 0;
    bottom: auto;
    max-height: 80vh;
  }
`;

export const searchSuggestionsList = css`
  position: relative;
  z-index: 1;
  cursor: pointer;
  &:after {
    content: '';
    position: absolute;
    left: 0px;
    right: 16px;
    bottom: 0;
    border-bottom: 1px solid ${colors.PrimaryWhiteColorAlpha15};
    ${MQ.MediaLg} {
      border-bottom: none;
    }
  }
`;

export const suggestionitem = css`
  cursor: pointer;
  padding: 16px 16px 16px 0;
  ${ZeeFontRegular(14, 16)}
  ${MQ.MediaLg} {
    padding: 16px;
    &:hover {
      background: ${colors.RecentSearchListOnHover};
    }
  }
`;

export const currentSuggestionItem = css`
  background: ${colors.RecentSearchListOnHover};
`;

export const SearchSuggestionsList = styled.div`
  ${searchSuggestionsList}
`;
export const Suggestionitem = styled.div`
  ${suggestionitem};
`;
export const SearchSuggestionsWrapper = styled.div`
  ${searchSuggestionsWrapper};
`;
